/* Product page: gallery thumb swap, accordion, mobile sticky buy bar. */

(function gallery() {
  const stage = document.getElementById('productStage');
  if (!stage) return;
  const thumbs = Array.from(document.querySelectorAll('[data-stage-thumb]'));
  const slides = Array.from(stage.querySelectorAll('[data-stage-slide]'));
  thumbs.forEach((t, i) => {
    t.addEventListener('click', () => {
      thumbs.forEach((x) => x.setAttribute('aria-current', 'false'));
      t.setAttribute('aria-current', 'true');
      slides.forEach((s) => s.classList.remove('active'));
      if (slides[i]) slides[i].classList.add('active');
    });
  });
})();

(function accordion() {
  const items = Array.from(document.querySelectorAll('.acc-item'));
  items.forEach((item) => {
    const btn = item.querySelector('.acc-trigger');
    const panel = item.querySelector('.acc-panel');
    if (!btn || !panel) return;
    btn.addEventListener('click', () => {
      const isOpen = item.getAttribute('aria-expanded') === 'true';
      items.forEach((other) => {
        other.setAttribute('aria-expanded', 'false');
        const op = other.querySelector('.acc-panel');
        if (op) op.style.height = '0px';
      });
      if (!isOpen) {
        item.setAttribute('aria-expanded', 'true');
        panel.style.height = panel.scrollHeight + 'px';
      }
    });
  });
  window.addEventListener('resize', () => {
    items.forEach((item) => {
      if (item.getAttribute('aria-expanded') === 'true') {
        const p = item.querySelector('.acc-panel');
        if (p) p.style.height = p.scrollHeight + 'px';
      }
    });
  });
})();

(function stickyBuy() {
  const bar = document.getElementById('stickyBuy');
  const trigger = document.getElementById('acquireBtn');
  const footer = document.querySelector('.footer');
  if (!bar || !trigger || !footer) return;
  function update() {
    const t = trigger.getBoundingClientRect();
    const f = footer.getBoundingClientRect();
    const pastTrigger = t.bottom < 60;
    const intoFooter = f.top < window.innerHeight - 40;
    const show = pastTrigger && !intoFooter;
    bar.classList.toggle('show', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
  }
  document.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
  window.addEventListener('resize', update);
  update();
})();

(function acquireForm() {
  const form = document.getElementById('acquireForm');
  if (!form) return;
  form.addEventListener('submit', (e) => {
    // Native Shopify cart POST. Show a soft "Added" state.
    const btn = form.querySelector('.btn-ink span');
    if (btn) {
      const original = btn.textContent;
      setTimeout(() => { btn.textContent = original; }, 2400);
      btn.textContent = 'Added to cart →';
    }
  });
})();
